




































































































































































import { AlertBanner, Scrollbar } from '@/app/components';
import { ArrowRightIcon, RefreshIcon } from '@vue-hero-icons/solid';
import { computed, defineComponent } from '@vue/composition-api';
import { TrinityRingsSpinner, SelfBuildingSquareSpinner } from 'epic-spinners';
import LineChart from '../components/charts/LineChart.vue';
import { useDashboard, useExceptionEvents, useFeatureFlags } from '../composable';
import { DashboardStatistic } from '../interfaces';

export default defineComponent({
    name: 'Dashboard',
    metaInfo: { title: 'Dashboard' },
    components: {
        AlertBanner,
        ArrowRightIcon,
        TrinityRingsSpinner,
        RefreshIcon,
        LineChart,
        Scrollbar,
        SelfBuildingSquareSpinner,
    },
    setup(props, { root }) {
        const { flag, areAnyEnabled } = useFeatureFlags();
        const isAnalyticsEnabled = flag('analytics');
        const { show: showExceptionEvents, count: exceptionCount, loading: loadingExceptions } = useExceptionEvents();
        const {
            asset,
            pipelineAndRetrieval,
            execution,
            loading: loadingStatistics,
            lastUpdatedOn: statisticsLastUpdatedOn,
            lastUpdatedSince: statisticsLastUpdatedSince,
            refetch,
            getDateRangeForLabel,
        } = useDashboard();

        const allCardsStats = computed<DashboardStatistic[]>(() => {
            return [...asset.value, ...pipelineAndRetrieval.value];
        });

        const loading = computed(() => loadingExceptions.value || loadingStatistics.value);

        const dataPointClicked = (point: { series: number; dataPoint: number }) => {
            const name = point.series === 0 ? 'dcj:monitoring' : 'workflow:monitoring';
            const category = execution.value.labels[point.dataPoint];

            root.$router.push({
                name,
                query: { period: 'custom', ...getDateRangeForLabel(category), ownership: 'organisation' },
            });
        };

        return {
            loading,
            showExceptionEvents,
            exceptionCount,
            asset,
            pipelineAndRetrieval,
            execution,
            loadingExceptions,
            statisticsLastUpdatedOn,
            statisticsLastUpdatedSince,
            isAnalyticsEnabled,
            areAnyEnabled,
            refetch,
            dataPointClicked,
            allCardsStats,
        };
    },
});
